module.exports = __webpack_public_path__ + "24-o1.jpg?212b8a7d952f3afe063b361c66c36918";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/24-o1.jpg
// module id = 648
// module chunks = 0